import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuardFxn } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    canActivate: [AuthGuardFxn],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth.route').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.route').then((m) => m.routes)
      }
    ]
  },
  {
    path: 'setPassword',
    loadComponent: () => import('./pages/set-password/set-password.component').then(
      (m) => m.SetPasswordComponent
    )
  }
];
RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled',
  scrollOffset:[0, 0]
});
